<template>
  <WhitePage>
    <title-bar>QA</title-bar>
    <!-- <help-nav></help-nav> -->
    <p>
      問い合わせいただいたもの等をこちらに記載します。
    </p>
    <ul>
      <li>一覧のアイコンはどうやって設定しますか？<br>
        ⇒今のところ、行動宣言のひとことで設定したアイコンに更新されます。そのうちなんとかします。</li>
      <li>屋内って何ですか？<br>
        ⇒今のところ意味はないですが、屋内のスポットならチェックを入れた方が良いです。</li>      
      <li>ブラウザでインストール・スマホでホーム追加したらどうなりますか？<br>
        ⇒クライアントが端末にインストールされます。受信が少なくなるので動作が速くなります。<br>
          ゲームアプリと同じ扱いになるため、クライアントがアップデートされた場合はタブを閉じて開きなおすまたはアプリを再起動してください。</li>
      <li>使う画像は？<br>
        ⇒アイコンは縦横120px、背景は縦300px横1000pxが良いと思います。</li>
      <li>「ひとことは２００字くらい」のくらいって何ですか？<br>
        ⇒太字等を設定すると背後にタグがつく都合上、２００字以下でもひっかかるときがあります。そのうちなんとかします。</li>
    </ul>
  </WhitePage>
</template>

<script>
// import phina from 'phina.js'
import WhitePage from '@/components/WhitePage'
import TitleBar from '@/components/TitleBar'
// import HelpNav from '@/components/HelpNav'
export default {
  components: {
    WhitePage,
    TitleBar,
    // HelpNav
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    // phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style scoped lang="scss">
h3 {
  margin: 2rem 10px 1.5rem;

  .subtitle {
    font-size: small;
    margin-left: 10px;
  }

}
p {
  margin: 0 10px 1rem;
}
.highlight {
  color: rgb(144, 24, 20);
}
</style>
